module.exports = __webpack_public_path__ + "img/vnsny1.246f2969.png";